import React, { FC } from "react";
import { StyledButton } from "./styles";
import { DISPLAY_SIZES } from "@lhd/types";
import { getDisplaySize } from "@lhd/components/DisplaySizeSelector/selector";
import { useSelector } from "react-redux";
import { BUTTON_HEIGHT, FONT_SIZE } from "@lhd/constants";
import { useLocation } from "react-router-dom";

export interface ButtonCommonArrowProps {
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  arrow?: "left" | "right";
  variant?: "primary" | "secondary";
  loading?: boolean;
}

const ButtonCommonArrow: FC<ButtonCommonArrowProps> = ({
  onClick,
  children,
  className,
  style,
  disabled,
  arrow,
  variant,
}) => {
  const displaySize = useSelector(getDisplaySize) as
    | keyof typeof FONT_SIZE
    | keyof typeof BUTTON_HEIGHT;
  const fontSize = FONT_SIZE[displaySize || DISPLAY_SIZES.SMALL];
  const height = BUTTON_HEIGHT[displaySize] ?? BUTTON_HEIGHT.small;
  const { pathname } = useLocation();

  const ignorePaths = [
    /^\/employment_contracts\/\d+\/create\/\d+$/,
    /^\/employment_contracts\/\d+\/edit\/\d+\/\d+$/,
  ];
  const shouldIgnore = ignorePaths.some((regex) => regex.test(pathname));

  const styleButton = shouldIgnore
    ? {
        ...style,
      }
    : {
        fontSize,
        height: `${height}px`,
        ...style,
      };
  return (
    <StyledButton variant={variant}>
      <button
        disabled={disabled}
        className={`button-view-detail ${className || ""}  ${arrow || ""}`}
        type="button"
        onClick={(e) => {
          e.preventDefault();
          onClick && onClick(e);
        }}
        style={{
          ...styleButton,
        }}
      >
        {children}
      </button>
    </StyledButton>
  );
};

export default ButtonCommonArrow;
